import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ThemeProvider } from "@mui/material";
import theme from "./theme.ts";
import { ApolloProvider } from "@apollo/client";
import client from "./graphql/apolloClient.ts";
import AppErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./redux/store.ts";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <ApolloProvider client={client}>
        <AppErrorBoundary>
          <BrowserRouter>
            <ReduxProvider store={store}>
            <App />
            </ReduxProvider>
          </BrowserRouter>
        </AppErrorBoundary>
      </ApolloProvider>
    </ThemeProvider>
  </StrictMode>
);
